// extracted by mini-css-extract-plugin
export var label = "_je-2";
export var slideContainer = "_je-0";
export var slider = "_je-1";